namespace Solovis.Reports.Parts {

    export interface SubReportControlOptions extends Solovis.Reports.Parts.PartControlOptions {                
    }

    export class SubReportControl extends Solovis.Reports.Parts.PartControl {

        public _persistedSettings;
        public printOnly: boolean;
        public usePersistedSettings: boolean;

        public reportControlHostDiv: JQuery;
        public reportControlHost: Solovis.UI.ControlHost;
        public subReportControl: Solovis.Reports.ReportControl;        

        constructor(options: SubReportControlOptions) {
            super(options);

            this._persistedSettings = options.persistedSettings ? options.persistedSettings : null;

            this.dataSets = null;

            this.printOnly = this.settings.printOnly ? true : false;
            this.usePersistedSettings = this.settings.usePersistedSettings ? true : false;            
        }


        public doInit() {
        }

        public doRender() {
            var self = this;

            this.container.addClass("sub-report-container");

            if (!this.dataSets) {
                return;
            }

            if (!this.reportControlHostDiv) {
                this.reportControlHostDiv = $("<div>").appendTo(this.container);
                this.reportControlHost = new Solovis.UI.ControlHost({ container: this.reportControlHostDiv });
            }

            if (this.printOnly && !this.printMode) {
                this.reportControlHost.setCurrentControl(null);
                return;
            }

            var persistedSettings = null;
            var persistedParameters = null;
            var persistedSubReportSettings = null;
            if (this.usePersistedSettings) {
                if (this.subReportControl) {
                    persistedSettings = this.getPersistedSettings();
                    persistedSubReportSettings = persistedSettings ? persistedSettings.subReport : null;
                    persistedParameters = persistedSettings ? persistedSettings.parameters : null;
                }
                else if (this._persistedSettings && this._persistedSettings.subReport) {
                    persistedSettings = this._persistedSettings;
                    persistedSubReportSettings = persistedSettings ? persistedSettings.subReport : null;
                    persistedParameters = persistedSettings ? persistedSettings.parameters : null;
                    this._persistedSettings = null;
                }
            }

            var more = {
                persistedSettings: persistedSettings
            };

            if (this.settings.reportOptions) {                
                try {
                    var reportConfig;

                    if (typeof this.settings.reportOptions == "function") {
                        reportConfig = this.settings.reportOptions.call(this, more);
                    }
                    else {
                        reportConfig = Solovis.deepCopy(this.settings.reportOptions);
                    }

                    if (this.usePersistedSettings && persistedParameters) {
                        // Any parameters that are not explicitly set should be restored
                        if (!reportConfig.parameters) {
                            reportConfig.parameters = Solovis.deepCopy(persistedParameters);
                        }
                        else {
                            for (var paramName in persistedParameters) {
                                if (typeof reportConfig.parameters[paramName] === 'undefined') {
                                    // Parameter not explicitly set, so use the persisted value.
                                    reportConfig.parameters[paramName] = Solovis.deepCopy(persistedParameters[paramName]);
                                }
                            }
                        }
                    }

                    if (reportConfig) {
                        reportConfig.printMode = this.printMode;
                        reportConfig.parentReportControl = this.reportControl;
                        reportConfig.persistedSettings = persistedSubReportSettings;
                        reportConfig.controlHost = this.reportControlHost;

                        // See if we should adjust first auto-run report options.
                        let parentRunOptions = this.reportControl.getActiveRunReportOptions();
                        let doNotUseCache = !!(parentRunOptions && parentRunOptions.doNotUseCache);
                        if (doNotUseCache && reportConfig.autoRun) {
                            if (!reportConfig.autoRunReportOptions) {
                                reportConfig.autoRunReportOptions = {};
                            }
                            reportConfig.autoRunReportOptions.doNotUseCache = true;                            
                        }                        

                        this.subReportControl = new Solovis.Reports.ReportControl(reportConfig);
                        this.reportControlHost.setCurrentControl(this.subReportControl);

                        this._notifySubReportControlChanged();
                    }
                    else {
                        if (this.reportControlHost) {
                            this.reportControlHost.setCurrentControl(null);
                        }
                        this.subReportControl = null;
                        this._notifySubReportControlChanged();
                    }
                }
                catch (error) {
                    if (typeof error == "string") {
                        self.container.append(error);
                    }
                    else if (error && error.message && typeof error.message == "string") {
                        self.container.append(error.message);
                    }
                    else {
                        self.container.append("Unknown error when rendering content of SubReportControl.");
                    }
                }
            }
        }


        public getPersistedSettings() {
            if (this.usePersistedSettings && this.subReportControl) {
                var persistedSettings: any = {};

                persistedSettings.subReport = this.subReportControl.collectPersistedSettings();
                persistedSettings.parameters = this.subReportControl.getSerializedParameterValues();

                return persistedSettings;
            }
            else {
                return null;
            }
        }        

        public getSubReportTitle() {
            if (this.subReportControl) {
                var reportTitle = this.subReportControl.getReportTitle();
                return reportTitle;
            }
            else {
                return null;
            }
        }

        public _notifySubReportControlChanged() {
            $(this).trigger("subReportControlChanged");
        }
    }

}

    
